<template>
  <!-- 办事大厅 -->
  <div class="oa">
    <p class="title">
      <span>{{title}}</span>
    </p>
    <p class="item">
      <span>{{promptData.configurationName}}</span>
      <span class="amount" @click="jump">{{ promptData.count }}</span>
      <span>{{promptData.unit}}</span>
    </p>
  </div>
</template>

<script>
  import promptApi from '@/api/loginPage/prompt';
  export default {
    name: "oa",
    components: {},
    props: {
      // 标题
      title: {
        type: String,
        default: "",
      },
      // 标识
      mark: {
        type: String,
        required: true,
      },
      typeId: {
        type: [String, Number],
        default: ''
      }
    },
    data() {
      return {
        promptData: {},
        link: ''
      };
    },
    created() {
      this.getDataByMark();
    },
    methods: {
      // 通过标识获取数据
      getDataByMark() {
        const parmas = {
          id: this.typeId
        }
        promptApi.queryPormptColumnInfo(parmas).then(res => {
          this.promptData = {...res.data[0]?.data}
          this.promptData.count = res.data[0]?.total
          this.link = res.data[0]?.data.address
        })
      },
      // 跳转方法
      jump() {
        if (this.link) {
          window.open(this.link);
        }
      },
    },
  };
</script>

<style lang="less">
  // 提醒之工资
  .oa {
    background-image: url(../../../../assets/remind/wages.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .item {
      .amount {
        margin: 0 10px;
        cursor: pointer;
        color: #fa6400;
      }
    }
  }
</style>
